import { createGlobalStyle } from 'styled-components/macro';
import { theme } from 'styled-tools';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
  }

  #root {
    height: inherit;
  }

  body {
    a, a:not([href]) {
      cursor: pointer;
      color: ${theme('link.color')};

      &:hover {
        color: ${theme('colors.primary')};
        text-decoration: underline;
      }
    }
  }
`;

export default GlobalStyle;
